import React from "react";

// Staffology Phase 4a — UK payroll overview (read-only).
// Shown on the payroll page for UK employees INSTEAD of the India-specific
// tax-regime / Form 16 sections. Displays the UK payroll config we capture
// (tax code, NI, pension, pay). It shows NO calculated PAYE/NI/net amounts —
// those arrive when UK pay runs go live (Phase 4c). This phase only fixes
// WHICH fields show, not the numbers.

const box = "rounded-xl border border-white/10 bg-white/[0.03] p-3";
const lbl = "text-[10px] text-white/35 uppercase tracking-wider";
const val = "text-sm text-white/85 mt-0.5";

function Cell({ label, children }) {
  return (
    <div className={box}>
      <p className={lbl}>{label}</p>
      <p className={val}>{children ?? <span className="text-white/30">—</span>}</p>
    </div>
  );
}

export default function UkPayrollOverview({ uk, regionSource }) {
  const u = uk || {};
  const pct = (v) => (v || v === 0 ? `${(Number(v) * 100).toFixed(1)}%` : null);
  const money = (v) => (v || v === 0 ? `£${Number(v).toLocaleString()}` : null);

  return (
    <section className="rounded-2xl border border-[#00ff90]/20 bg-[#00ff90]/[0.03] p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-[#00ff90] font-semibold">UK Payroll (PAYE)</h2>
          <p className="text-white/40 text-xs mt-0.5">
            Your UK payroll details — Income Tax (PAYE), National Insurance and pension.
          </p>
        </div>
        <span className="text-[10px] px-2 py-0.5 rounded-full border border-[#00ff90]/25 text-[#00ff90]/80">
          Region: UK
        </span>
      </div>

      {!u.has_profile && (
        <p className="text-xs text-amber-400/80 mb-3">
          Your UK payroll details haven’t been set up yet — an admin can add them in Payroll Details.
        </p>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <Cell label="Tax Code">{u.tax_code}</Cell>
        <Cell label="NI Category">{u.ni_category}</Cell>
        <Cell label="NI Number">{u.ni_number}</Cell>
        <Cell label="Pay Basis">{u.pay_basis}</Cell>
        <Cell label="Pay Amount">{money(u.pay_amount)}</Cell>
        <Cell label="Pay Period">{u.pay_period}</Cell>
        <Cell label="Pension (employee)">{pct(u.pension_ee_pct)}</Cell>
        <Cell label="Pension (employer)">{pct(u.pension_er_pct)}</Cell>
        <Cell label="Student Loan">{u.student_loan_plan || "None"}</Cell>
      </div>

      <p className="text-[11px] text-white/30 mt-3">
        PAYE, National Insurance and net-pay figures will appear here once UK pay runs go live.
      </p>
    </section>
  );
}
